const images =
`# Embedding Images


#### Cloning the repo to local machine:

![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/clone.gif)

#### Running first time install \`\`\`npm install\`\`\`:

![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/install1.gif)

#### Running development server \`\`\`npm run dev\`\`\`:

![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/dev.gif)

#### Running build process \`\`\`npm run build\`\`\`:

![link to build](https://github.com/ICJIA/icjia-simple-webpack-example//raw/master/howto/build.gif)

## Screen capture
- [Giphy](http://giphy.com/)
`

export {images}



// WEBPACK FOOTER //
// ./src/boilerplates/images.js